interface HeaderProps {
  title: React.ReactNode;
  subtitle?: string;
  rightActions?: React.ReactNode;
}

export default function Header({ title, subtitle, rightActions }: HeaderProps) {
  return (
    <header className="flex items-center justify-between px-4 sm:px-6 lg:px-10 py-3 sm:py-4 lg:py-5 bg-grey">
      <div>
        <h1 className="text-xl sm:text-2xl lg:text-3xl">{title}</h1>
        {subtitle && <p className="text-gray-500 text-sm sm:text-base lg:text-[18px] mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{rightActions}</div>
    </header>
  );
}
